export default __webpack_public_path__ + "static/media/1036.980b4525.png";